import { Helmet } from "react-helmet";
import Infografics from "../infografics/Infografics";
import "../../assets/styles/pages.scss";
import "../../assets/styles/form.scss";
import "../../assets/styles/antd.scss";
import "../../assets/styles/details.scss";
const Dashboard = () => {
  return (
    <div>
      <Helmet>
        <title>Orhan Door | Admin</title>
      </Helmet>
      <Infografics />
    </div>
  );
};

export default Dashboard;
